import React from 'react';

const Arrow = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0.358978 30.1544L26.5177 3.90804C27.3356 3.09012 27.1312 2.68116 25.9043 2.68116L0.359249 2.76988L2.06812 1.06101L30.8117 1.01611L30.768 29.76L29.0591 31.469V5.83598C29.0591 4.6091 28.6209 4.43384 27.7447 5.31018L1.67349 31.469L0.358978 30.1544Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default Arrow;
